// @ts-nocheck
import {
  EventEmitter, OnDestroy, Component, ElementRef, Inject, Input, OnInit, Output, Renderer2, ViewChild,
} from '@angular/core';
import { get } from 'lodash';
import { fromEvent, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { RestApiService } from '../../service/rest-api.service';
import { AnalyticsService } from '../../service/analytics.service';
import { P } from '../../ui-kit';
import { UiKitService } from '../../ui-kit.service';

@Component({
  selector: 'lib-book-a-call',
  templateUrl: './book-a-call.component.html',
  styleUrls: ['./book-a-call.component.scss'],
  exportAs: 'libBookACall',
})
export class BookACallComponent implements OnInit, OnDestroy {
  @Output() event: EventEmitter<any> = new EventEmitter();

  @ViewChild('container', { static: true }) container: ElementRef<HTMLDivElement>;

  // tslint:disable-next-line: no-input-rename
  @Input('organization') organization = 'proportunity';

  // tslint:disable-next-line: no-input-rename
  @Input('room') room = 'chat-with-us';

  // tslint:disable-next-line: no-input-rename
  @Input('doneBtn') doneBtn = 'Done';

  // tslint:disable-next-line: no-input-rename
  @Input('user') user: Partial<P.User<P.Applicant>>;

  // tslint:disable-next-line: no-input-rename
  @Input('confirmationTitle') confirmationTitle = 'Thanks for booking a call with us!';

  // tslint:disable-next-line: no-input-rename
  @Input('confirmationMessage') confirmationMessage = 'Our team is looking forward to speaking with you.';

  subscription: P.Dictionary<Subscription> = {};

  toggle: P.Dictionary<boolean> = {};

  data;

  defaultAvatar = 'https://i2.wp.com/blog.stylingandroid.com/wp-content/uploads/2017/06/toggle_checked.png?resize=240%2C240&ssl=1';

  private destroyFn: () => void;

  constructor(
    @Inject('config') private config: any,
    private restApi: RestApiService,
    private analytics: AnalyticsService,
    private uikit: UiKitService,
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
    //
    this.toggle.working = true;
    //
    this.closeCalendlyInlineWidget();
    //
    this.uikit.windowObject('Calendly', 'showPopupWidget', (calendly) => {
      //
      const subscription = `${BookACallComponent.name}-calendly-event`;
      // returns html element with class name
      const elementWithClass = (className: string): HTMLElement => {
        const el = this.renderer.createElement('div');
        el.className = className;
        return el;
      };
      // create overlay element
      const overlay: HTMLElement = elementWithClass('book-a-call-overlay'); // 'calendly-overlay'
      const overlaySubscription = `${subscription}-overlay`;
      //
      this.destroyFn = (event?: MouseEvent | TouchEvent) => {
        this.uikit.clearSubscription(subscription, this.subscription);
        this.renderer.removeChild(this.container.nativeElement, overlay);
      };
      //
      this.subscription[overlaySubscription] = fromEvent(overlay, 'click')
        .subscribe(() => this.closeCalendlyInlineWidget());
      // create overlay container element
      const overlayContainer = elementWithClass('book-a-call-popup'); // 'calendly-popup'
      overlay.appendChild(overlayContainer);
      // append overlay to dom
      this.renderer.appendChild(this.container.nativeElement, overlay);
      // init calendly in overlay element
      const user = this.user;
      //
      const phone = user?.phone
        ? `${user?.phone}`.replace(/^0/gi, '+44')
        : '';
      //
      const base = {
        name: user?.first_name
          ? `${user?.first_name} ${user?.last_name || ''}`
          : '',
        email: user?.email || '',
      };
      //
      const custom = phone
        ? { customAnswers: { a1: phone } }
        : {};
      //
      const prefill = {
        ...base,
        ...custom,
      };
      //
      calendly
        .initInlineWidget({
          url: `https://calendly.com/${this.organization}/${this.room}`,
          parentElement: overlayContainer,
          prefill,
        });
      //
      this.event.emit({ type: 'book-a-call', data: this.room });
      // listen to calendly events
      this.subscription[subscription] = fromEvent(window, 'message')
        .pipe(filter((e) => get(e, 'data.event')
          && get(e, 'data.event').indexOf('calendly') === 0))
        .subscribe((e) => {
          const calendlyEvent = get(e, 'data.event');
          //
          this.toggle.working = false;
          //
          switch (calendlyEvent) {
            // event modal opened
            case 'calendly.event_type_viewed':
              //
              this.toggle.event_type_viewed = true;
              //
              this.event.emit({ type: 'book_a_call_event_type_viewed', data: this.room });
              break;
            // on call time & date selected
            case 'calendly.date_and_time_selected':
              this.toggle.date_and_time_selected = true;
              //
              this.event.emit({ type: 'book_a_call_date_and_time_selected', data: this.room });
              break;
            // on call scheduled
            case 'calendly.event_scheduled':
              this.toggle.event_scheduled = true;
              this.event.emit({ type: 'booked-a-call', data: {} });
              break;
            default:
          }
        });
    });
  }

  ngOnDestroy(): void {
    this.closeCalendlyInlineWidget();
  }

  closeCalendlyInlineWidget(event?: MouseEvent | TouchEvent): void {
    if (event) {
      this.event.emit({
        type: 'close-booked-a-call',
        data: {
          organization: this.organization,
          room: this.room,
        },
      });
    }

    if (this.destroyFn) {
      this.destroyFn();
    }

    this.destroyFn = void 0;
  }
}
